<!--header region -->
<mat-toolbar>
  <mat-toolbar-row>

    <div class="header">
      <div class="header_firstHeader">

        <!-- <div>
          <button mat-icon-button id="menu" (click)="menuChange(true)">
            <mat-icon id="menuID" class="menuIcon" [inline]="true">menu</mat-icon>
          </button>
        </div> -->

        <div class="header_firstHeader_logo" fxFlex="14" fxFlex.sm="40" fxFlex.xs="40">
          <img src='{{logo ? logo : "assets/images/mainLogo.png" }}' [routerLink]="homeUrl" />
        </div>
        <div *ngIf="sharedService.currentUser.LabclientId > 0" style="flex:0 0 12%">
          {{businessName}}
        </div>

        <div fxFlex="63" class="header_firstHeader_pathDetail">
          <ng-container *ngIf="currentPath == '/dashboard'">
            <div class="userWelcome">
              <p>Welcome, {{currentUser?.Username}}</p>
            </div>
          </ng-container>
          <ng-container *ngIf="currentPath != '/dashboard'">
            <div>
              <span class="header_firstHeader_pathDetail_link" *ngFor="let item of breadcrumbHistory;let i = index"
                (click)="moveToPage(item)">
                <u>{{item?.name}}</u> {{breadcrumbHistory.length === (i+1) ? '' : '/' }}
              </span>
            </div>
            <div style="font-size: 13px;display: inline;vertical-align: bottom;">{{sharedService.pathName}}</div>
          </ng-container>
        </div>

        <div *ngIf="(notificationIcon)" style="padding-left: 20px;">
          <button class="flashit" mat-icon-button color="warn" matBadge="{{notificationListCount + notificationListTestOnHoldCount + newDrugsCount}}"  matBadgeColor="warn" matTooltip="Notification" style="line-height: 47px!important" (click)="redirectToReminder()">
            <mat-icon style="font-size: 28px;">notifications</mat-icon>
          </button>
        </div>

        <div fxFlex="auto" fxHide.sm="true" fxHide.xs="true" class="header_firstHeader_userDetails">
          <div>
            <span>{{currentUser?.Username}} | </span>
            <span (click)="userLogOut()"> Sign Out | </span>
            <span (click)="changePassword()">Change Password </span>
          </div>
          <div>
            <span>{{currentUser?.LoginDateTime}}</span>
          </div>
          <div>
            <span (click)="labPrinter()">Lab Printer | </span>
            <span (click)="privacyPolicy()">Privacy Policy | </span>
            <span (click)="manual()">Manual | </span>
            <span (click)="support()">Support</span>
          </div>
        </div>

        <div fxFlex="auto" fxHide.xl="true" fxHide.lg="true" fxHide.md="true"
          class="header_firstHeader_userDetailsMobileView">
          <i class="fas fa-user-circle" [matMenuTriggerFor]="menu1"></i>
          <mat-menu #menu1="matMenu">
            <button mat-menu-item>{{currentUser?.Username}}</button>
            <button mat-menu-item (click)="userLogOut()">Sign Out</button>
            <button mat-menu-item (click)="changePassword()">Change Password</button>
            <button mat-menu-item>{{currentUser?.LoginDateTime}}</button>
            <button mat-menu-item (click)="labPrinter()">Lab Printer</button>
            <button mat-menu-item (click)="privacyPolicy()">Privacy Policy</button>
            <button mat-menu-item (click)="manual()">Manual</button>
            <button mat-menu-item (click)="support()">Support</button>
          </mat-menu>
        </div>
      </div>

    </div>

  </mat-toolbar-row>

  <mat-toolbar-row style="padding-top: 20px;">
    <div class="header_firstHeader" style="background-color:#ffffff; color:#000000 !important">
      <button mat-icon-button id="menu" (click)="menuChange(true)">
        <mat-icon id="menuID" class="menuIcon" [inline]="true">menu</mat-icon>
      </button>
    </div>
  </mat-toolbar-row>

</mat-toolbar>
<!--eof header region -->

<!--side bar menu region -->
<mat-sidenav-container>

  <mat-sidenav [(opened)]="appDrawerOpen" (mouseleave)="menuChange(false)">
    <mat-nav-list>
      <mat-accordion>
        <ng-container *ngFor="let item of sideMenu">
          <mat-expansion-panel [expanded]="expanMenu(item.child)">
            <mat-expansion-panel-header>
              <span class="list-header">
                {{item?.name}}
              </span>
            </mat-expansion-panel-header>

            <ng-container *ngFor="let child of item.child">
              <a id="menuChangeID" class="list-item" mat-list-item [routerLink]='[child.url]'
                routerLinkActive="list-item-active" (click)="menuChange(false)">
                <span>{{child?.name}}</span>
              </a>
            </ng-container>
          </mat-expansion-panel>
        </ng-container>
      </mat-accordion>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <custom-message></custom-message>
    <!-- <ng-container>
      <div *ngIf="displayErrors" class="errorMessage" [innerHTML]="errorMessage">
      </div>
      <div *ngIf="displaySuccesses" class="successMessage" [innerHTML]="successMessage">
      </div>
      <div *ngIf="displayInformation" class="infoMessage" [innerHTML]="infoMessage">
      </div>
    </ng-container> -->
    <router-outlet></router-outlet>
  </mat-sidenav-content>

</mat-sidenav-container>
<!--eof side bar menu region -->